import {
  createCompositeStore
} from "../__chunks/WFO54Y6U.js";
import "../__chunks/QEFBF7I4.js";
import "../__chunks/LK6LFO7X.js";
import {
  defaultValue
} from "../__chunks/NWU4GBZ6.js";
import "../__chunks/O35LWD4W.js";
import "../__chunks/5XEKIOCW.js";
import {
  __spreadProps,
  __spreadValues
} from "../__chunks/4BKCJXBM.js";

// src/toolbar/toolbar-store.ts
function createToolbarStore(props = {}) {
  var _a;
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  return createCompositeStore(__spreadProps(__spreadValues({}, props), {
    orientation: defaultValue(
      props.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "horizontal"
    ),
    focusLoop: defaultValue(props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  }));
}
export {
  createToolbarStore
};
